import {
  FieldDefinition,
  NodeDefinition,
  NodeDefinitions,
  TabDefinition
} from '../pages/editor/editorSlice';
import { NodeKind } from '../pages/editor/diagram/nodes/DataNodeModel';
import { RuntimeMode, useGetConfigQuery } from '../app/apiSlice';

export const useCatalog = () => {
  const { data : config } = useGetConfigQuery();
  const ADVANCED_TAB = 'Configuration avancée';

  const addDefaultBasicProperties = (nodeDefinition: NodeDefinition) => {
    let schemaTabs: TabDefinition[] = nodeDefinition.tabs ? [...nodeDefinition.tabs] : [];
    const settings: { [key: string]: FieldDefinition } = {...nodeDefinition.settings};
    const basicProperties = config?.runtimeMode.find(runtime => runtime.name === RuntimeMode.BASIC);

    if (basicProperties?.properties) {
      const keys = settings ? Object.keys(settings) : [];
      const undefinedSettings = basicProperties.properties.filter(property => !keys.includes(property.key));

      if (undefinedSettings.length > 0) {
        let tabAdvancedIndex = schemaTabs.findIndex(tab => tab.name === ADVANCED_TAB);
        if (tabAdvancedIndex !== -1) {
          schemaTabs = schemaTabs.map((tab, index) =>
              index === tabAdvancedIndex ?
                  { name: ADVANCED_TAB,
                    fields: tab.fields.concat(undefinedSettings.map(s => s.key)),
                    description: tab.description,
                    advanced_description: tab.advanced_description
                  } : tab);
        } else {
          schemaTabs.push({name: ADVANCED_TAB, fields: undefinedSettings.map(s => s.key), description: ''});
        }

        undefinedSettings.forEach(uSetting => {
          settings[uSetting.key] = {
            name: uSetting.name,
            type: uSetting.type,
            help: uSetting.help,
            value: uSetting.value
          }
        });
      }
    }
    return {...nodeDefinition, tabs: schemaTabs, settings};
  }


  return {
    getSchema: (name: string, kind: string, catalog: NodeDefinitions): NodeDefinition | undefined => {
      if (kind !== NodeKind.NOTE) {
        // @ts-ignore
        for (const n of catalog[kind + "s"]) {
          if (n.name === name && n.kind === kind) {
            if (n.runtimeMode === RuntimeMode.BASIC && !n.noDefaultProperties) {
              return addDefaultBasicProperties(n);
            } else {
              return n;
            }
          }
        }
      }
      return undefined;
    },
  };
};
